import React, { FC } from 'react'
import { useSelector } from 'react-redux'

import { Heading } from '@ucheba/ui/components/Heading/desktop'

import { newsSelectors } from '@ucheba/store/institutions/news'
import { Banner } from '../../../../../components/Banner/desktop'
import LayoutInstitution from '../../../../../components/LayoutInstitution/desktop'
import NewsList from './NewsList'

import EmptyListPlaceholder from '../../components/EmptyListPlaceholder'
import { useBannerProgramTypes } from '../../utils/useBannerProgramTypes'
import { isPaidPackage } from '../../utils/isPaidPackage'

const InstitutionNewsPage: FC = () => {
  const news = useSelector(newsSelectors.entity)

  const { extraParams, paidPackage } = useBannerProgramTypes()

  return (
    <>
      <LayoutInstitution>
        <Heading as='h1' h2='Новости' spacing='large' />

        {!news.total ? (
          <EmptyListPlaceholder title='В этом учебном заведении пока нет новостей' />
        ) : (
          <NewsList />
        )}
      </LayoutInstitution>

      {!isPaidPackage(paidPackage) && <Banner id={6} extraParams={extraParams} />}

      {!isPaidPackage(paidPackage) && <Banner id={14} extraParams={extraParams} />}
    </>
  )
}

export default InstitutionNewsPage
